// Import model
import { DataviewContentResultResponse } from '../models/DataviewContentResultResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContentResult } from '../models/ContentResult';
import { DataView } from '../models/DataView';
import { FilterContentResultRequest } from '../models/FilterContentResultRequest';

// Import dependency serializers (for complex types)
import { ContentResultSerializer } from './ContentResultSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContentResultRequestSerializer } from './FilterContentResultRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContentResultResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContentResultResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContentResultResponse instance
   */
  static deserialize(json: string): DataviewContentResultResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContentResultResponse instance
   */
  static fromObject(obj: any): DataviewContentResultResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContentResultResponse');
    }


    const instance: DataviewContentResultResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContentResultSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContentResultRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContentResultResponse instances
   */
  static deserializeArray(json: string): DataviewContentResultResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContentResultResponse instance to a JSON string
   */
  static serialize(instance: DataviewContentResultResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContentResultResponse instance to a plain object
   */
  static toObject(instance: DataviewContentResultResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContentResultSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContentResultRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContentResultResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContentResultResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
